import type { IconProps } from './types';
import './icons.css';

export default function AnimatedDots({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      height={height || 40}
      width={width || 40}
      viewBox="0 0 40 40"
      className={`animated-dots ${className}`}
    >
      <circle className="dot" cx="10" cy="20" r="3" />
      <circle className="dot" cx="20" cy="20" r="3" />
      <circle className="dot" cx="30" cy="20" r="3" />
    </svg>
  );
}
